import React, { memo } from "react";
import { makeStyles } from "tss-react/mui";
import { Box } from "@mui/material";
import { useAccountingContext } from "../../AccountingProvider";
import { AccountingListActionMenu } from "../AccountingListActionMenu/AccountingListActionMenu";

export const AllInvoiceActions = memo((props: any) => {
  const { classes } = useStyles();
  const { actionMenuRef } = useAccountingContext();

  return (
    <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
      <Box className={classes.actionContainer}>
        <AccountingListActionMenu
          ref={actionMenuRef as React.Ref<{ order: object }>}
          menuViewConfig={{
            forceCloseOut: false,
            orderActivityDetails: true,
            printInvoices: false,
            voidOrder: false,
          }}
          {...props}
        />
      </Box>
    </Box>
  );
});

const useStyles = makeStyles()((theme) => ({
  actionContainer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    marginTop: theme.spacing(1),
    [theme.breakpoints.down("xl")]: {
      justifyContent: "space-between",
    },
  },
}));
